import type { State } from 'src/models';
import { WorkSession } from 'src/models/workSessions';
import { calculateActualSessionTimePassedSeconds } from 'src/utils/workSessions.utils';

export const getTickTimestamp = (state: State): number => state.workSessions.tickTimestamp;
export const getEndTimestamp = (state: State): number => state.workSessions.endTimestamp;
export const getSessionTimePassedSeconds = (state: State): number => state.workSessions.sessionTimePassedSeconds;
export const getIsPaused = (state: State): boolean => state.workSessions.playTimestamp === null;
export const getPlayTimestamp = (state: State): number | null => state.workSessions.playTimestamp;
export const getSession = (state: State): WorkSession => state.workSessions.session;
export const getCurrentSession = (state: State): number => state.workSessions.currentSession;
export const getTotalSessionsCount = (state: State): number => state.workSessions.sessionsCount;
export const getNotification = (state: State): string | void => state.workSessions.notification;
export const getActualSessionTimePassedSeconds = (state: State): number =>
  calculateActualSessionTimePassedSeconds(state.workSessions);
export const getIsManualRewind = (state: State): boolean => state.workSessions.isManualRewind;
